import React from 'react'

export default () => (
  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 2V7" stroke="#0E4462" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M6 2V7" stroke="#0E4462" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
)
